import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};

  `;
};

export const Container = styled.div`
  display: grid;
  grid-template-columns: 45% 45%;
  justify-content: space-between;
  margin-top: 16px;
  ${handleQuery(css`
    grid-template-columns: 100%;
    gap: 16px;
  `)}
`;

export const ContainerText = styled.div`
  max-width:240px;
  ${handleQuery(css`
      max-width:100%;
  `)}
`;

export const ContentMore = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;

  ${({ color }) =>
    css`
      background-color: ${color};
    `}
`;

export const ContentField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  ${handleQuery(css`
    justify-content: flex-start;
  `)}
`;

export const Field = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* align-items: center; */
  gap: 12px;
  padding: 8px 0;

  ${handleQuery(css`
    grid-template-columns: 1fr;
    width: 100%;
  `)}
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${handleQuery(css`
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
  `)}
`;

export const DetailContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  ${handleQuery(css`
    flex-direction: column;
    align-items: flex-end;
  `)}
`;
